import { z } from 'zod';
export const SponsorSchema = z.object({
    id: z.string().uuid(),
    eventId: z.string().uuid(),
    name: z.string(),
    tier: z.string(),
    description: z.string(),
    logoPath: z.string().nullable(),
    websiteUrl: z.string().url().nullable(),
    sortOrder: z.number().int(),
    /** The one sponsor per event whose mark prints on every attendee's QR card. */
    featuredOnCards: z.boolean(),
});
export const CreateSponsorRequestSchema = z.object({
    name: z.string().min(1).max(200),
    tier: z.string().min(1).max(40),
    description: z.string().max(2000).optional(),
    logoPath: z.string().nullable().optional(),
    websiteUrl: z.string().url().nullable().optional(),
    sortOrder: z.number().int().optional(),
});
/** `featuredOnCards` is PATCH-only — see the backend schema for why. */
export const PatchSponsorRequestSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    tier: z.string().min(1).max(40).optional(),
    description: z.string().max(2000).optional(),
    logoPath: z.string().nullable().optional(),
    websiteUrl: z.string().url().nullable().optional(),
    sortOrder: z.number().int().optional(),
    featuredOnCards: z.boolean().optional(),
});
/**
 * One of an event's sponsor tiers. `key` is what `Sponsor.tier` holds and never
 * changes; `label` is the display name and is the only thing a rename touches.
 */
export const SponsorTierSchema = z.object({
    key: z.string(),
    label: z.string(),
    sortOrder: z.number().int(),
});
/** `GET /v1/events/:eventId/sponsor-tiers` rows: a tier with how many sponsors use it. */
export const SponsorTierWithCountSchema = SponsorTierSchema.extend({
    sponsorCount: z.number().int(),
});
export const CreateSponsorTierRequestSchema = z.object({ label: z.string().min(1).max(40) });
export const RenameSponsorTierRequestSchema = z.object({ label: z.string().min(1).max(40) });
export const ReorderSponsorTiersRequestSchema = z.object({ keys: z.array(z.string()).min(1) });
//# sourceMappingURL=sponsors.js.map